import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import initial from '../locales/catalog.json';
import core from '../locales/core.json';
import workspace from '../locales/workspace.json';
import actions from '../locales/actions.json';
import platform from '../locales/platform.json';
import deletions from '../locales/deletions.json';
import currencies from '../locales/currencies.json';
import partners from '../locales/partners.json';
import customerWallet from '../locales/customer-wallet.json';
import payments from '../locales/payments.json';
import qrCash from '../locales/qr-cash.json';
import passwordReset from '../locales/password-reset.json';

const catalog = Object.fromEntries(Object.entries({ ...initial, ...core, ...workspace, ...actions, ...platform, ...deletions, ...currencies, ...partners, ...customerWallet, ...payments, ...qrCash, ...passwordReset }).map(([key, value]) => [key, Array.isArray(value) ? { so: value[0], de: value[1] } : value]));
const canonical = new Map(Object.keys(catalog).map(key => [key.toLowerCase(), key]));
const original = new Map(Object.entries(catalog).flatMap(([key, value]) => [[value.so, key], [value.de, key]]));

const resources = Object.fromEntries(['en', 'so', 'de'].map(locale => [locale, { translation: Object.fromEntries(Object.entries(catalog).map(([key, values]) => [key, locale === 'en' ? key : values[locale]])) }]));
i18n.use(initReactI18next).init({ resources, lng: 'en', fallbackLng: 'en', supportedLngs: ['en', 'so', 'de'],
  keySeparator: false, nsSeparator: false, returnNull: false, initImmediate: false, interpolation: { escapeValue: false } });

// Exact, catalogued UI messages only. Never translates customer data or substrings.
export const t = (key, values) => typeof key === 'string' ? i18n.t(canonical.get(key.toLowerCase()) || key, values) : key;
export const uiText = value => typeof value === 'string' ? t(original.get(value) || value) : value;
const templates = Object.keys(catalog).filter(key => /{{\w+}}/.test(key)).map(key => {
  const params = [...key.matchAll(/{{(\w+)}}/g)].map(match => match[1]);
  const pattern = key.split(/{{\w+}}/).map(part => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('(.+?)');
  return { key, params, pattern: new RegExp('^' + pattern + '$') };
});
export const errorText = value => {
  if (typeof value !== 'string') return t('Something went wrong');
  if (canonical.has(value.toLowerCase()) || original.has(value)) return uiText(value);
  for (const item of templates) { const match = item.pattern.exec(value); if (match) return t(item.key, Object.fromEntries(item.params.map((key, index) => [key, match[index + 1]]))); }
  return i18n.resolvedLanguage === 'en' ? value : t('Request could not be completed. Check the details and try again.');
};
export default i18n;